<ng-container *ngIf="activeOrg">
  <div class="col mx-3">
    <div class="row">
      <div class="col-auto">
        <div class="row">
          <ng-container
            *ngFor="
              let locale of locales | async;
              let i = index;
              let l = length
            "
          >
            <div
              *ngIf="visible(locale.symbol)"
              class="col-auto px-0"
              [class.hidable]="hidable"
              [class.active]="locale.symbol === activeLocale"
              [class.ml-auto]="i === 0 && alignRight"
            >
              <button
                type="button"
                class="btn btn-link btn-sm border-bottom border-left border-right mt-0"
                [class.active]="activeLocale === locale.symbol"
                (click)="onSelect(locale)"
                ngbTooltip="{{
                  (locale.symbol !== activeOrg.locale.split('-')[0]
                    ? locale.name
                    : 'input-flags.default'
                  ) | translate
                }}"
              >
                <i
                  class="fi fi-{{ locale.flag }}"
                  *ngIf="locale.symbol !== activeOrg.locale.split('-')[0]; else default"
                ></i>
                <ng-template #default>
                  <i class="fe fe-flag"></i>
                </ng-template>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
